<cac-dialog-layout title='Upload Image' (onSubmit)="onSubmit()" [formGroup]="formGroup">
  <div class="w-44 flex-shrink-0">
    <cac-image-uploader
      [control]="formGroup.controls.image"
      class="h-44 my-6"
    />
    <cac-field [control]="formGroup.controls.order" label="Order" />
  </div>
</cac-dialog-layout>
